export const messages = {
  en: {
    home: 'home',
    zhichi: 'support',
    more: 'Get the latest InHand device documentation, firmware, and development tools to stay up-to-date',
    download: 'Download',
    Firmware: 'Firmware',
    ziyuan: 'resource center',
    name: 'NAME',
    type: 'TYPE',
    date: 'DATE',
    load: 'loading...',
    file: 'FILE',
    FileName:"File Name",
    Version:"Version",
    Size:"Size",
    Products:"Products",
    Descriptions:"Descriptions",
    ReleaseNotes:"Release Notes",
    Checksum:"Checksum",
    Document:"Document",
    Tools:"Tools",
  },
  cn:{

    home: '首页',
    zhichi: '支持',
    ziyuan: '资源中心',
    more: '获取最新的InHand设备文档、固件和开发工具，随时掌握最新信息。',
    download: '下载',
    Firmware: '固件',
    name: '名称',
    type: '文件类型',
    date: '发布日期',
    file: '文件',
    load: '加载中...',
    FileName:"文件名",
    Version:"版本号",
    Size:"文件大小",
    Products:"产品",
    Descriptions:"描述",
    ReleaseNotes:"发布说明",
    Checksum:"校验和",
    Document:"文档",
    Tools:"开发者工具",

  }
};
